import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { Reveal, Overline } from "./Reveal";
import { scrollToId } from "./SmoothScroll";

const IMG = { retailer: "/img/shop2.jpg", distributor: "/img/store.jpg", shg: "/img/woman1.jpg" };

export const Solutions = () => {
  const { t } = useLang();
  const s = t.solutions;
  const [tab, setTab] = useState("retailer");
  const d = s[tab];

  return (
    <section id="solutions" className="py-24 lg:py-32" data-testid="solutions-bento">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div className="max-w-2xl">
            <Overline>{s.over}</Overline>
            <h2 className="section-title mt-5">{s.title}</h2>
          </div>
          <div className="flex flex-wrap gap-2 rounded-full border border-white/10 p-1.5">
            {Object.keys(IMG).map((k) => (
              <button
                key={k}
                onClick={() => setTab(k)}
                data-testid={`solution-tab-${k}`}
                className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-colors duration-300 ${tab === k ? "bg-white text-ink" : "text-slate-300 hover:text-white"}`}
              >
                {s.tabs[k]}
              </button>
            ))}
          </div>
        </Reveal>

        <motion.div key={tab} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }} className="mt-12 grid auto-rows-[minmax(180px,auto)] grid-cols-1 gap-4 md:grid-cols-4">
          <div className="bento relative min-h-[320px] overflow-hidden p-0 md:col-span-2 md:row-span-2">
            <img src={IMG[tab]} alt={s.tabs[tab]} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
            <div className="absolute bottom-0 p-7">
              <span className="rounded-full bg-saffron px-3 py-1 text-xs font-bold uppercase tracking-wider text-ink">{s.tabs[tab]}</span>
              <h3 className="mt-4 max-w-md font-display text-2xl font-bold leading-tight text-white lg:text-3xl" data-testid="solution-heading">{d.h}</h3>
            </div>
          </div>
          <div className="bento md:col-span-2">
            <p className="text-base leading-relaxed text-slate-200">{d.d}</p>
            <div className="mt-6 flex flex-wrap gap-2">
              {d.cats.map((c) => (
                <span key={c} className="rounded-full border border-white/15 px-3 py-1.5 text-xs text-slate-200">{c}</span>
              ))}
            </div>
          </div>
          <div className="bento flex flex-col justify-between">
            <p className="font-display text-5xl font-extrabold text-emerald">{d.k1}</p>
            <p className="text-sm text-slate-300">{d.k1l}</p>
          </div>
          <button onClick={() => scrollToId("join")} data-testid="solution-join-btn" className="bento group flex flex-col justify-between bg-saffron text-left text-ink hover:bg-saffron-hover">
            <ArrowRight size={28} className="transition-transform duration-300 group-hover:translate-x-2" />
            <span>
              <span className="block font-display text-4xl font-extrabold">{d.k2}</span>
              <span className="text-sm font-medium">{d.k2l}</span>
              <span className="mt-3 block text-sm font-bold">{s.cta} {s.tabs[tab]} →</span>
            </span>
          </button>
        </motion.div>
      </div>
    </section>
  );
};
